import {
	display,
	displayToast,
	fetchPropertyInfo,
	selectSession,
} from '../redux/slices/sessionSlice';
import { faCheckCircle, faDownload } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QRCode from 'react-qr-code';
import React from 'react';
import { useAppSelector } from '../redux/hook';
import { useTranslation } from 'react-i18next';

//import { selectSession } from '../redux/slices/sessionSlice';

export default function Thanks() {
	const { t } = useTranslation();
	//const { reservation, propertyInfo } = useAppSelector(selectSession);
	const {
		token,
		reservation,
		profiles,
		propertyInfo,
		documentMetaData,
		settings,
	} = useAppSelector(selectSession);

	const enableQRCode = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableThankYouQRCode' &&
			setting.parameterValue?.toLowerCase() === 'true'
	);

	const enableDigitalKey = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableDigitalKey' &&
			setting.parameterValue?.toLowerCase() === 'true'
	);

	const enableKeyDescrption = settings?.find(
		(setting: any) =>
			setting.parameterName === 'EnableKeyDescrption' &&
			setting.parameterValue?.toLowerCase() === 'true'
	);
	return (
		<div
			className="d-flex flex-column vh-100 mx-auto"
			style={{ overflow: 'auto' }}>
			{/* {propertyInfo?.propertyCode == 'YAM' ||
			process.env.REACT_APP_THEME == 'YAM' ? ( */}
			<>
				<img
					className="theme-header-img"
					src={process.env.PUBLIC_URL + '/logo-header.svg'}></img>
			</>

			<div
				className="d-flex flex-column justify-content-center align-items-center w-100 text-white theme-header"
				style={{ background: '#03355C', minHeight: '80px' }}>
				<h2 className="fs-2 m-0">{t('ThankyouPageHeader')}</h2>
			</div>

			<div
				className="mb-2 mx-auto"
				style={{
					maxWidth: '1200px',
				}}>
				<div className="m-4 bg-white p-2 rounded-4 shadow-sm">
					<div className="text-center">
						<div className="mt-2">
							<img
								src={process.env.PUBLIC_URL + '/green-tick.jpeg'}
								alt="Success"
								height={100}
							/>
						</div>

						<div className="mt-2">
							<strong>{t('ThankyouPageMessage1')}</strong>
						</div>
						<div
							className="mt-3 mb-3 px-5 theme-thank-you"
							style={{
								color: '#03355C',
							}}>
							<h2 className="fs-4">{t('ThankyouPageMessage2')}</h2>
						</div>

						{enableQRCode ? (
							<>
								<hr className="col-lg-12 mt-4 mb-4" />
								<div className="mt-3 mx-1 lh-1">
									{t('ThankyouPageQRCodeMessage1')}
								</div>
								{/* {propertyInfo?.propertyCode == 'YAM' ||
								process.env.REACT_APP_THEME == 'YAM' ? ( */}
								<div className="mt-2">
									{t('ThankyouPageQRCodeMessage2')}
									{reservation?.PmsConfirmationNo}
								</div>
								{/* ) : null} */}
								<div className="mt-4 mb-4 ">
									<QRCode value={reservation?.PmsConfirmationNo} size={128} />
								</div>
							</>
						) : null}
						{/* {propertyInfo?.propertyCode == 'YAM' ||
						process.env.REACT_APP_THEME == 'YAM' ? null : ( */}
						<div className="theme-thank-you-property-info">
							<hr />
							<div className="mt-2">
								<strong
									style={{
										color: '#03355C',
										margin: '10px',
									}}>
									{propertyInfo?.property}
								</strong>
								<br />
								<label>{propertyInfo?.address}</label>
								<br />
								<a
									href={propertyInfo?.webSite}
									target="_blank"
									rel="noopener noreferrer">
									{propertyInfo?.webSite}
								</a>
							</div>
						</div>
						{/* )} */}
					</div>
				</div>

				{enableDigitalKey && (
					<>
						<div className="d-flex flex-column px-4 align-content-center justify-content-center text-center bg-white m-4 p-3 rounded-4 shadow-sm">
							<p>
								{t('ThankyouPageKeyMessage1')}
								{propertyInfo?.propertyCode ?? ''}{' '}
								{t('ThankyouPageKeyMessage2')}
							</p>
							<button
								className="btn mx-auto"
								style={{
									backgroundColor: '#03355C',
									color: '#fff',
									maxWidth: '400px',
								}}
								onClick={() => {
									// window.location.href = 'https://samsotech-id.com';
								}}>
								<div className="d-flex flex-row gap-2 align-content-center justify-content-center">
									<FontAwesomeIcon icon={faDownload} />
									<span
										style={{
											fontSize: '0.9rem',
										}}>
										{t('ThankyouPageKeyMessage3')}
									</span>
								</div>
							</button>
						</div>
					</>
				)}
				{enableKeyDescrption && (
					<>
						<p className="text-center">{t('ThankyouPageKeyMessage5')}</p>
					</>
				)}
			</div>
		</div>
	);
}
